﻿import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils";
import { queryKeys } from "../queryKeys";
import { CandidateComment } from "../models/CandidateComment";
import { validateUuid } from "../../utils";

export function useCandidateComments(tenantId: string | undefined, entityId: string | undefined, candidateId: string | undefined) {
    const axios = axiosInstance();
    return useQuery({
        ...queryKeys.candidateComments.byCandidateId(candidateId),
        queryFn: () =>
            axios
                .get<CandidateComment[]>(
                    `api/Clients/${validateUuid(tenantId)}/entities/${validateUuid(entityId)}/candidates/${validateUuid(candidateId)}/comments`
                )
                .then(response => response.data),
    });
}
